import React, { useEffect, useRef, useState } from "react";
import "../../../../Assets/Styles/Chatbot.scss";
import "../../../../Assets/Styles/Communication.scss";
import ChatInput from "./Components/ChatInput";
import ChatbotHeader from "./Components/ChatbotHeader";
import TypingIndicator from "./Components/TypingIndicator";
import TimeoutModal from "./Components/TimeoutModal";
import AskmMeBotLogo from "../../../../Assets/Images/ask-me-bot-blue-filled.svg";
import CXBotLogo from "../../../../Assets/Images/cx-bot-blue-filled.svg";
import axios from "axios";
import InfoToast from "../ShareElements/Toast/InfoToast";
import BotMessageItem from "./Components/BotMessageItem";
import { formatDate } from "../../../../Helper_functions";

const AskMeBot = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const chatBotElement = useRef();
  const ChatbotTimeRef = useRef(null);
  const ChatbotAlertRef = useRef(null);

  const [showHeaderBanner, setShowHeaderBanner] = useState(
    localStorage.getItem("showChatbotOnBoardingBanner")
  );
  const [headerBannerMessage, setHeaderBannerMEssage] = useState(
    translateText("chatbot_onboarding_banner_text")
  );
  const [ConversationMessages, setConversationMessages] = useState([]);
  const [IndicatorIsShown, setIndicatorIsShown] = useState(false);
  const [PlaceholderText, setPlaceholderText] = useState(
    translateText("write_a_message")
  );
  const [TimeoutDuration, setTimeoutDuration] = useState(10); // the value is in minutes
  const [TimeoutModalIsOpen, setTimeoutModalIsOpen] = useState(false);
  const [TimeoutWarning, setTimeoutWarning] = useState(0);
  const [InitialHintIsShown, setInitialHintIsShown] = useState(true);
  const [ToastIsShown, setToastIsShown] = useState(false);

  const handleNewConversationMessage = (isMe, content, id, isError) => {
    setConversationMessages((prevState) => {
      const TodayConversation = prevState.find(
        (conversation) => conversation.date === "Today"
      );

      // if today is not in array, we need to add it in array
      if (!TodayConversation) {
        return [
          ...prevState,
          {
            date: "Today",
            conversations: [
              {
                isMe,
                content,
                id,
                isError,
              },
            ],
          },
        ];
      } else {
        return prevState?.map((ConversationInfo) => {
          // we are only adding conversation under Today's
          if (ConversationInfo.date === "Today") {
            return {
              date: ConversationInfo.date,
              conversations: [
                ...ConversationInfo.conversations,
                {
                  isMe,
                  content,
                },
              ],
            };
          } else {
            return ConversationInfo;
          }
        });
      }
    });
  };

  // sending messages is handled by this function
  // WillInform is set to true when we want a n action to
  // happen on the chatbot and the message is not just a text
  const handleInputSubmit = (e) => {
    e.preventDefault();

    let UserMessage = document.getElementById("ask-me-input").value;
    document.getElementById("ask-me-input").value = "";

    let MessageItem = {
      content: UserMessage,
      isMe: true,
    };

    if (UserMessage.length > 0) {
      handleNewConversationMessage(true, UserMessage);

      setIndicatorIsShown(true);

      if (InitialHintIsShown) {
        setInitialHintIsShown(false);
      }
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.ASKMEANYTHING_URL + "/process",
      data: {
        token: window.localStorage.getItem("Token"),
        message: UserMessage,
      },
    };

    if (UserMessage.length > 0) {
      axios(Req)
        .then((Res) => {
          console.log(Res);
          setTimeout(() => {
            setIndicatorIsShown(false);
            handleNewConversationMessage(false, Res.data.response, Res.data.id);
          }, 200);
        })
        .catch((Err) => {
          console.log(Err);
          if (Err.response?.status === 403) {
            setIndicatorIsShown(false);
            displayErrorMessage(translateText("faq_limit_error"));
          }
        });
    }
  };

  const displayErrorMessage = (ErrorMessage) => {
    handleNewConversationMessage(false, ErrorMessage, undefined, true);
  };

  const handleDataHistory = (conversationsList) => {
    const newDataStructure = [];

    conversationsList?.forEach((conversations, conversationsIdx) => {
      // last item is the conversation date
      const today = formatDate(new Date(), true);
      const date = formatDate(conversations.pop(), true);
      const dateIdx = newDataStructure.findIndex(
        (conversation) =>
          conversation.date === date || conversation.date === "Today"
      );

      if (dateIdx > -1) {
        const conversationHistory = conversations.map((msg, msgIdx) => ({
          content: msg,
          isMe: msgIdx === 0,
          id: `${conversationsIdx}-${msgIdx}`,
        }));

        newDataStructure[dateIdx].conversations.push(...conversationHistory);
      } else {
        newDataStructure.push({
          date: date === today ? "Today" : date,
          conversations: conversations.map((msg, msgIdx) => {
            // idx 0 is user's question history
            // idx 1 is ask me anything's answer history
            return {
              content: msg,
              isMe: msgIdx === 0,
              id: `${conversationsIdx}-${msgIdx}`,
            };
          }),
        });
      }
    });

    return newDataStructure;
  };

  const getChatHistory = () => {
    let Req = {
      method: "POST",
      baseURL: window._env_.ASKMEANYTHING_URL + "/history",
      data: {
        token: window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        if (InitialHintIsShown && Res.data.conversation.length) {
          setInitialHintIsShown(false);
        }

        setTimeout(() => {
          setIndicatorIsShown(false);
          setConversationMessages(handleDataHistory(Res.data.conversation));
        }, 200);
      })
      .catch((Err) => {
        console.log(Err);
        if (Err.response?.status === 403) {
          setIndicatorIsShown(false);
          displayErrorMessage(translateText("faq_limit_error"));
        }
      });
  };

  useEffect(() => {
    scrollChat();
  }, [ConversationMessages, props.IsOpen]);

  useEffect(() => {
    getChatHistory();
  }, []);

  const scrollChat = () => {
    if (document.getElementById("ask-me-message-items")) {
      let ScrollHeight = document.getElementById(
        "ask-me-message-items"
      ).scrollHeight;
      document.getElementById("ask-me-message-items").scrollTop = ScrollHeight;
    }
  };

  const toggleInputChange = (e) => {};

  const handleHeaderArrowClick = () => {
    setShowHeaderBanner(Boolean(!showHeaderBanner));
    localStorage.setItem("showChatbotOnBoardingBanner", "");
  };

  const handleClose = () => {
    document.getElementById("ask-me-chatbot-main").classList.remove("is-open");
    props.SetIsOpen(false);
    setTimeout(() => {
      props.Close();
    }, 250);
  };

  const handleDeleteConversation = () => {
    setConversationMessages([]);

    let Req = {
      method: "POST",
      baseURL: window._env_.ASKMEANYTHING_URL + "/session",
      data: {
        token: window.localStorage.getItem("Token"),
      },
    };

    // just hit the API to notify that user request to delete conversation history
    axios(Req);
  };

  const handleMainAreaClicks = (e) => {
    e.stopPropagation();
    resetBotTimeouts();
  };

  const resetBotTimeouts = () => {
    handleChatbotSessionTimeout();
    handleChatbotSessionTimeoutWarning();
  };

  const handleChatbotSessionTimeout = (Timeout) => {
    if (ChatbotTimeRef.current) {
      clearTimeout(ChatbotTimeRef.current);
    }

    if (!Timeout) {
      Timeout = TimeoutDuration;
    }
    let Duration = Timeout * 60000; // in milliseconds

    ChatbotTimeRef.current = setTimeout(() => {}, Duration);
  };

  const handleChatbotSessionTimeoutWarning = (Timeout) => {
    if (ChatbotAlertRef.current) {
      clearTimeout(ChatbotAlertRef.current);
    }

    if (!Timeout) {
      Timeout = TimeoutWarning;
    }
    let Duration = Timeout * 60000; // in milliseconds

    ChatbotAlertRef.current = setTimeout(() => {
      //   setTimeoutModalIsOpen(true);
    }, Duration);
  };

  const handleTimeoutAccept = () => {
    resetBotTimeouts();
    setTimeoutModalIsOpen(false);
  };

  const displayToast = () => {
    setToastIsShown(true);
    setTimeout(() => {
      setToastIsShown(false);
    }, 2000);
  };

  return (
    <>
      {/* <input hidden id="last-fast-reply" type="text" /> */}
      {TimeoutModalIsOpen ? (
        <TimeoutModal
          Cancel={() => setTimeoutModalIsOpen(false)}
          Accept={() => handleTimeoutAccept()}
          AlertInfo={
            translateText("your_session_will_end_in") +
            " " +
            parseInt(TimeoutDuration - TimeoutWarning) +
            " " +
            translateText("minutes") +
            ". " +
            translateText("chatbor_inactivity_text")
          }
          AlertText={translateText("session_timeout_warning")}
          MinutesLeft={TimeoutDuration - TimeoutWarning}
          translateText={(LabelId) => translateText(LabelId)}
        />
      ) : null}
      <div
        className="overlay"
        style={
          !props.IsOpen
            ? { zIndex: -9999, opacity: 0, pointerEvents: "none" }
            : null
        }
      ></div>
      <div
        className="outline"
        style={
          !props.IsOpen
            ? { zIndex: -9999, opacity: 0, pointerEvents: "none" }
            : null
        }
        onClick={() => handleClose()}
      >
        <section
          className={props.IsOpen ? "chatbot-main is-open" : "chatbot-main"}
          id="ask-me-chatbot-main"
          ref={chatBotElement}
          onClick={(e) => handleMainAreaClicks(e)}
        >
          {ToastIsShown ? (
            <InfoToast
              InfoMessage={
                <span className="toast-content">
                  <i className="feather-copy"></i>
                  <p>{translateText("copied_to_clipboard")}</p>
                </span>
              }
              dismiss={() => setToastIsShown(false)}
              ButtonText={translateText("dismiss").toUpperCase()}
            />
          ) : null}
          {/*Chatbot Head*/}
          <ChatbotHeader
            showHeaderBanner={showHeaderBanner}
            onHeaderArrowClick={handleHeaderArrowClick}
            Close={() => handleClose()}
            CustomTitle={translateText("assistify")}
            WillHideBanner
            message={headerBannerMessage}
            LangData={props.LangData}
            ReqDeleteConversation={() => handleDeleteConversation()}
            SetChatbotType={(Type) => props.SetChatbotType(Type)}
          />
          {/*chatbot content*/}
          <div className="chatbot-content">
            {/*chatbot Messages*/}
            <div className="messages ask-me-messages">
              <div className="conversation-wrapper" id="ask-me-message-items">
                {InitialHintIsShown ? (
                  <div className="hints-wrapper">
                    <section className="hint-item">
                      <img alt="" src={AskmMeBotLogo} />
                      <main className="hint-content">
                        <h1>{translateText("assistify")}:</h1>
                        <p>{translateText("ask_me_info_1")}</p>
                      </main>
                    </section>
                    <section className="hint-item">
                      <img alt="" src={CXBotLogo} />
                      <main className="hint-content">
                        <h1>CX Copilot:</h1>
                        <p>{translateText("ask_me_info_2")}</p>
                      </main>
                    </section>
                  </div>
                ) : null}
                {ConversationMessages?.map(
                  (conversationItem, conversationItemIdx) => (
                    <div key={conversationItemIdx}>
                      <div className="message-date-wrapper">
                        <span>
                          {conversationItem.date === "Today"
                            ? translateText("today")
                            : conversationItem.date}
                        </span>
                      </div>
                      {conversationItem?.conversations?.map(
                        (MessageItem, idx) => (
                          <div key={MessageItem.id + conversationItemIdx}>
                            {MessageItem.isMe ? (
                              <div
                                className={
                                  idx === 0
                                    ? "message-item first-item"
                                    : "message-item"
                                }
                              >
                                <>
                                  {props.UserInfo.imageThumbnailUrl ? (
                                    <img
                                      className="user-avatar"
                                      src={props.UserInfo.imageThumbnailUrl}
                                    />
                                  ) : (
                                    <span
                                      style={{
                                        backgroundColor:
                                          props.UserInfo.backgroundColorCode,
                                        color: props.UserInfo.textColorCode,
                                      }}
                                      className="user-avatar avatar-placeholder"
                                    >
                                      {props.UserInfo.firstName
                                        .slice(0, 1)
                                        .toUpperCase() +
                                        props.UserInfo.lastName
                                          .slice(0, 1)
                                          .toUpperCase()}
                                    </span>
                                  )}
                                </>
                                <p className="message-item-content">
                                  {MessageItem.content}
                                </p>
                              </div>
                            ) : (
                              <>
                                {MessageItem.isError ? (
                                  <div className="message-item is-bot is-bot-error">
                                    <i className="feather-alert-circle"></i>
                                    <section>
                                      <h1>
                                        {translateText(
                                          "daily_request_limit_reached"
                                        )}
                                      </h1>
                                      <p className="message-item-content">
                                        {MessageItem.content}
                                      </p>
                                    </section>
                                  </div>
                                ) : (
                                  <BotMessageItem
                                    LangData={props.LangData}
                                    AskmMeBotLogo={AskmMeBotLogo}
                                    DisplayToast={() => displayToast()}
                                    MessageItem={MessageItem}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        )
                      )}
                    </div>
                  )
                )}
              </div>
            </div>

            {IndicatorIsShown ? <TypingIndicator /> : null}

            <ChatInput
              onInputSubmit={(e) => handleInputSubmit(e)}
              onChangeHandler={(e) => toggleInputChange(e)}
              PlaceholderText={translateText("write_a_message")}
              LangData={props.LangData}
              CustomId="ask-me-input"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default AskMeBot;
